import { Leaf } from '@holistic/components/icons';

/** Ürün adımının altındaki sürdürülebilirlik şeridi. */
const EcoBand = () => (
  <div className="bg-primary/5 flex flex-col gap-5 rounded-2xl p-5 md:flex-row md:items-center">
    <div className="flex flex-1 items-start gap-4">
      <span className="bg-primary/10 flex size-11 shrink-0 items-center justify-center rounded-xl">
        <Leaf className="text-primary size-5" />
      </span>
      <div className="space-y-1">
        <p className="text-sm font-semibold text-gray-900">
          Daha uzun ömürlü bir teknoloji için.
        </p>
        <p className="text-xs leading-relaxed text-gray-600">
          Tamir ettirerek hem bütçenizi koruyun hem de elektronik atığın
          azalmasına katkı sağlayın.
        </p>
      </div>
    </div>

    <div className="border-primary/15 shrink-0 text-sm leading-snug md:border-l md:pl-6">
      <p className="font-semibold text-gray-900">Küçük bir tamir,</p>
      <p className="text-gray-600">büyük bir fark yaratır.</p>
    </div>
  </div>
);

export default EcoBand;
